(() => {
  const selector = '.acidology-language-menu';

  const closeMenus = (except) => {
    document.querySelectorAll(selector).forEach((menu) => {
      if (menu !== except) menu.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    const menu = event.target.closest(selector);
    if (menu) {
      closeMenus(menu);
    } else {
      closeMenus();
    }

    const languageButton = event.target.closest('[data-acidology-language-code]');
    if (languageButton) {
      const form = languageButton.closest('form');
      const input = form?.querySelector('[data-acidology-language-input]');
      if (input) input.value = languageButton.dataset.acidologyLanguageCode;
    }

    const closeButton = event.target.closest('[data-acidology-close-language]');
    if (!closeButton) return;

    const closeMenu = closeButton.closest(selector);
    if (closeMenu) closeMenu.removeAttribute('open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenus();
  });
})();

(() => {
  const gallery = document.querySelector('[data-acidology-gallery]');
  if (!gallery) return;

  const previous = document.querySelector('[data-acidology-gallery-prev]');
  const next = document.querySelector('[data-acidology-gallery-next]');

  const step = () => {
    const card = gallery.querySelector('.acidology-product-card');
    const gap = Number.parseFloat(getComputedStyle(gallery).columnGap || getComputedStyle(gallery).gap) || 24;
    return (card?.getBoundingClientRect().width || gallery.clientWidth * 0.75) + gap;
  };

  previous?.addEventListener('click', () => gallery.scrollBy({ left: -step(), behavior: 'smooth' }));
  next?.addEventListener('click', () => {
    const distance = step();
    const remaining = gallery.scrollWidth - gallery.clientWidth - gallery.scrollLeft;
    gallery.scrollTo({
      left: remaining <= distance * 1.15 ? gallery.scrollWidth : gallery.scrollLeft + distance,
      behavior: 'smooth'
    });
  });
})();

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const items = document.querySelectorAll(
    '.template-index .acidology-hero-content > *, .template-index .acidology-trust-item, .template-index .acidology-home-collections-head > *, .template-index .acidology-product-card, .template-index .acidology-about-left > *, .template-index .acidology-about-visual, .template-index .acidology-about-card, .template-index .acidology-proof-heading, .template-index .acidology-proof-card'
  );
  if (!items.length) return;

  items.forEach((item, index) => {
    item.classList.add('acidology-reveal');
    item.style.setProperty('--acidology-reveal-delay', `${(index % 4) * 70}ms`);
  });
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  items.forEach((item) => observer.observe(item));
})();

(() => {
  const initializeLuxuryProduct = () => {
    const root = document.querySelector('[data-acidology-luxury-product]');
    if (!root) return;

    // Progressive disclosure keeps the purchase column concise.
    const moreToggle = root.querySelector('.acidology-luxury-more-toggle');
    const morePanel = root.querySelector('.acidology-luxury-more');
    const moreLabel = moreToggle?.querySelector('.acidology-luxury-more-label');
    const moreCopy = morePanel?.querySelector('.acidology-luxury-more-copy');
    const purchasePanel = root.querySelector('.acidology-luxury-info-sticky');

    const keepVisibleInPurchasePanel = (target) => {
      if (!purchasePanel || !target || window.matchMedia('(max-width: 900px)').matches) return;

      const panelRect = purchasePanel.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const safeTop = panelRect.top + 18;
      const safeBottom = panelRect.bottom - 24;

      if (targetRect.bottom > safeBottom) {
        purchasePanel.scrollBy({ top: targetRect.bottom - safeBottom, behavior: 'smooth' });
      } else if (targetRect.top < safeTop) {
        purchasePanel.scrollBy({ top: targetRect.top - safeTop, behavior: 'smooth' });
      }
    };

    if (moreCopy) {
      const normalizeCopy = (value) =>
        value
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      const redundantSectionLabels = [
        'qualité et matériaux',
        'qualite et materiaux',
        'ce qui est inclus',
        'quality and materials',
        'what is included',
        'calidad y materiales',
        'qué incluye',
        'que incluye',
      ];

      const originalMarkup = moreCopy.innerHTML;
      const lowerMarkup = originalMarkup.toLocaleLowerCase();
      const sectionIndexes = redundantSectionLabels
        .map((label) => lowerMarkup.indexOf(label))
        .filter((index) => index >= 0);

      if (sectionIndexes.length) {
        const firstRedundantSection = Math.min(...sectionIndexes);
        const containingTag = originalMarkup.lastIndexOf('<', firstRedundantSection);
        const cutoff = containingTag >= 0 ? containingTag : firstRedundantSection;
        moreCopy.innerHTML = originalMarkup.slice(0, cutoff).trim();
      }

      // Shopify descriptions may contain the same editorial copy twice.
      // Keep the first occurrence while preserving the original rich text.
      const title = root.querySelector('.acidology-luxury-header h1')?.textContent?.trim();
      if (title) {
        const source = moreCopy.innerHTML;
        const lowerSource = source.toLocaleLowerCase();
        const marker = title.toLocaleLowerCase();
        const firstTitle = lowerSource.indexOf(marker);
        const repeatedTitle = firstTitle >= 0 ? lowerSource.indexOf(marker, firstTitle + marker.length) : -1;

        if (repeatedTitle > source.length * 0.35) {
          moreCopy.innerHTML = source.slice(0, repeatedTitle).trim();
        }
      }

      const seenBlocks = new Set();
      Array.from(moreCopy.children).forEach((block) => {
        const normalized = normalizeCopy(block.textContent || '');
        if (!normalized) {
          block.remove();
          return;
        }

        if (seenBlocks.has(normalized)) {
          block.remove();
          return;
        }

        seenBlocks.add(normalized);
      });

      // Turn legacy line-break descriptions into readable editorial paragraphs.
      if (moreCopy.children.length <= 1 && moreCopy.querySelector('br')) {
        const paragraphs = moreCopy.innerHTML
          .split(/<br\s*\/?>/gi)
          .map((line) => line.trim())
          .filter(Boolean);

        if (paragraphs.length > 1) {
          moreCopy.innerHTML = paragraphs.map((line) => `<p>${line}</p>`).join('');
        }
      }
    }

    moreToggle?.addEventListener('click', () => {
      const shouldOpen = !morePanel?.classList.contains('is-open');
      morePanel?.classList.toggle('is-open', shouldOpen);
      morePanel?.setAttribute('aria-hidden', String(!shouldOpen));
      moreToggle.classList.toggle('is-open', shouldOpen);
      moreToggle.setAttribute('aria-expanded', String(shouldOpen));
      if (moreLabel) {
        moreLabel.textContent = shouldOpen ? moreToggle.dataset.lessLabel : moreToggle.dataset.moreLabel;
      }

      if (shouldOpen) {
        window.setTimeout(() => {
          keepVisibleInPurchasePanel(root.querySelector('.acidology-luxury-accordions'));
        }, 460);
      }
    });

    // Only one specification panel stays open at a time.
    const accordions = root.querySelectorAll('.acidology-luxury-accordion');
    let accordionVisibilityTimer = 0;

    accordions.forEach((accordion) => {
      const toggle = accordion.querySelector('.acidology-luxury-accordion-toggle');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const shouldOpen = !accordion.classList.contains('is-open');
        window.clearTimeout(accordionVisibilityTimer);

        accordions.forEach((item) => {
          item.classList.remove('is-open');
          item.querySelector('.acidology-luxury-accordion-toggle')?.setAttribute('aria-expanded', 'false');
          item.querySelector('.acidology-luxury-accordion-panel')?.setAttribute('aria-hidden', 'true');
        });

        if (shouldOpen) {
          accordion.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          accordion.querySelector('.acidology-luxury-accordion-panel')?.setAttribute('aria-hidden', 'false');

          accordionVisibilityTimer = window.setTimeout(() => {
            const nextToggle = accordion.nextElementSibling?.querySelector('.acidology-luxury-accordion-toggle');
            const openedPanel = accordion.querySelector('.acidology-luxury-accordion-panel');
            keepVisibleInPurchasePanel(nextToggle || openedPanel || toggle);
          }, 460);
        } else {
          keepVisibleInPurchasePanel(toggle);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLuxuryProduct, { once: true });
  } else {
    initializeLuxuryProduct();
  }
})();

(() => {
  const localeMatch = window.location.pathname.match(/^\/(en|es)(?=\/)/);
  const localePrefix = localeMatch ? `/${localeMatch[1]}` : '';

  const toLocalPath = (path) => `${localePrefix}${path}`;

  const productRoutes = {
    'molecular-distortion': 'koi-japonais',
    'distorsion-moleculaire': 'koi-japonais',
    'brutalist-echo': 'astronaute-renaissance',
    'architecture-brutaliste': 'astronaute-renaissance',
    'flora-mutata': 'tigre-encre-noire',
    'botanique-mutante': 'tigre-encre-noire',
    'digital-suture': 'dragon-japonais',
    'glitch-numerique': 'dragon-japonais',
  };

  const titleRoutes = [
    { text: 'koi japonais', handle: 'koi-japonais' },
    { text: 'astronaute renaissance', handle: 'astronaute-renaissance' },
    { text: 'tigre encre noire', handle: 'tigre-encre-noire' },
    { text: 'dragon japonais', handle: 'dragon-japonais' },
  ];

  const normalizeLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const rawHref = link.getAttribute('href') || '';
      const label = (link.textContent || '').trim().toLowerCase();

      if (['collections', 'collections acidology', 'colecciones'].includes(label)) {
        link.setAttribute('href', toLocalPath('/collections/collections-acidology'));
        return;
      }

      try {
        const url = new URL(rawHref, window.location.origin);
        const path = url.pathname.replace(/^\/(en|es)(?=\/)/, '');

        if (
          path === '/collections' ||
          path === '/collections/' ||
          path === '/collections/all' ||
          path === '/pages/collections' ||
          path === '/collections/acidology' ||
          path === '/collections/collection-acidology' ||
          path === '/collections/collections'
        ) {
          link.setAttribute('href', toLocalPath('/collections/collections-acidology'));
          return;
        }

        Object.entries(productRoutes).forEach(([oldHandle, newHandle]) => {
          if (path === `/products/${oldHandle}` || path.startsWith(`/products/${oldHandle}/`)) {
            link.setAttribute('href', `${toLocalPath(`/products/${newHandle}`)}${url.search}${url.hash}`);
          }
        });
      } catch (error) {
        Object.entries(productRoutes).forEach(([oldHandle, newHandle]) => {
          if (rawHref.includes(`/products/${oldHandle}`)) {
            link.setAttribute('href', toLocalPath(`/products/${newHandle}`));
          }
        });
      }

      const cardText = (
        link.closest('.acidology-luxury-related-item, .acidology-home-card, .acidology-product-card, article')?.textContent || ''
      ).toLowerCase();
      titleRoutes.forEach(({ text, handle }) => {
        if (cardText.includes(text)) {
          link.setAttribute('href', toLocalPath(`/products/${handle}`));
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeLinks);
  } else {
    normalizeLinks();
  }
})();

(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  onReady(() => {
    const section = document.querySelector('.acidology-product-v2');
    if (!section) return;

    const revealItems = section.querySelectorAll('.acidology-product-reveal');
    section.classList.add('is-motion-ready');

    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.16 }
      );

      revealItems.forEach((item) => revealObserver.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    section.querySelectorAll('[data-acidology-product-fact]').forEach((fact) => {
      const toggle = fact.querySelector('.acidology-detail-toggle');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const shouldOpen = !fact.classList.contains('is-open');

        section.querySelectorAll('[data-acidology-product-fact]').forEach((item) => {
          item.classList.remove('is-open');
          item.querySelector('.acidology-detail-toggle')?.setAttribute('aria-expanded', 'false');
        });

        if (shouldOpen) {
          fact.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    const description = section.querySelector('.acidology-product-description');
    if (description) {
      const normalizeText = (value) =>
        value
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      description.querySelectorAll('h2, h3, h4').forEach((heading) => {
        const label = normalizeText(heading.textContent || '');
        const isMaterialsHeading =
          label === 'qualite et materiaux' ||
          label === 'quality and materials' ||
          label === 'calidad y materiales';
        const isIncludedHeading =
          label === 'ce qui est inclus' ||
          label === 'what is included' ||
          label === 'que incluye' ||
          label === 'incluido';

        if (isMaterialsHeading) {
          let sibling = heading.nextElementSibling;
          while (sibling && !sibling.matches('h2, h3, h4')) {
            const next = sibling.nextElementSibling;
            sibling.remove();
            sibling = next;
          }
          heading.remove();
          return;
        }

        if (!isIncludedHeading) return;

        const list = heading.nextElementSibling;
        if (list?.matches('ul, ol')) list.remove();
        heading.remove();
      });

      description.querySelectorAll('p').forEach((paragraph) => {
        const copy = normalizeText(paragraph.textContent || '');
        if (/^(important|importante)\b/.test(copy)) paragraph.remove();
      });

      const displayedTitle = normalizeText(section.querySelector('.acidology-product-summary h1')?.textContent || '');
      const firstParagraph = description.querySelector('p');
      const leadingElement = firstParagraph?.firstElementChild;
      const leadingCopy = normalizeText(leadingElement?.textContent || '');

      if (
        displayedTitle &&
        leadingElement &&
        ['STRONG', 'B', 'SPAN'].includes(leadingElement.tagName) &&
        leadingCopy === displayedTitle
      ) {
        leadingElement.remove();

        const leadingText = Array.from(firstParagraph.childNodes).find(
          (node) => node.nodeType === 3 && node.nodeValue.trim()
        );

        if (leadingText) {
          leadingText.nodeValue = leadingText.nodeValue.replace(
            /^(\s*)(\S)/,
            (_match, spacing, firstCharacter) => `${spacing}${firstCharacter.toUpperCase()}`
          );
        }
      }
    }

    const mainFrame = section.querySelector('.acidology-product-main-image');
    const mainImage = mainFrame?.querySelector('img');
    const lightbox = section.querySelector('.acidology-product-lightbox');
    const lightboxImage = lightbox?.querySelector('img');
    const closeButton = lightbox?.querySelector('.acidology-product-lightbox-close');
    const backdrop = lightbox?.querySelector('.acidology-product-lightbox-backdrop');
    const thumbs = section.querySelectorAll('[data-acidology-lightbox-src]');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const precisePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const artCursor = section.querySelector('.acidology-art-cursor');

    if (!reducedMotion && precisePointer) {
      let pointerFrame = 0;
      let pointerX = 0;
      let pointerY = 0;

      const paintPointer = () => {
        const bounds = section.getBoundingClientRect();
        const normalizedX = Math.max(-1, Math.min(1, ((pointerX - bounds.left) / bounds.width - 0.5) * 2));
        const normalizedY = Math.max(-1, Math.min(1, ((pointerY - bounds.top) / Math.max(bounds.height, 1) - 0.18) * 2));

        section.style.setProperty('--acidology-parallax-x', `${normalizedX * 8}px`);
        section.style.setProperty('--acidology-parallax-y', `${normalizedY * 6}px`);
        section.style.setProperty('--acidology-title-x', `${normalizedX * -13}px`);
        section.style.setProperty('--acidology-title-y', `${normalizedY * -8}px`);

        if (artCursor) {
          artCursor.style.setProperty('--acidology-cursor-x', `${pointerX}px`);
          artCursor.style.setProperty('--acidology-cursor-y', `${pointerY}px`);
        }

        pointerFrame = 0;
      };

      section.addEventListener('pointermove', (event) => {
        pointerX = event.clientX;
        pointerY = event.clientY;
        if (!pointerFrame) pointerFrame = window.requestAnimationFrame(paintPointer);
      });

      section.addEventListener('pointerleave', () => {
        section.style.setProperty('--acidology-parallax-x', '0px');
        section.style.setProperty('--acidology-parallax-y', '0px');
        section.style.setProperty('--acidology-title-x', '0px');
        section.style.setProperty('--acidology-title-y', '0px');
        artCursor?.classList.remove('is-active');
      });

      mainFrame?.addEventListener('pointerenter', () => artCursor?.classList.add('is-active'));
      mainFrame?.addEventListener('pointerleave', () => artCursor?.classList.remove('is-active'));
    }

    if (!mainFrame || !mainImage || !lightbox || !lightboxImage) return;

    const open = (source = mainImage.currentSrc || mainImage.src, alt = mainImage.alt || '') => {
      lightboxImage.src = source;
      lightboxImage.alt = alt;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    const close = () => {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImage.removeAttribute('src');
      document.documentElement.style.overflow = '';
    };

    mainFrame.setAttribute('role', 'button');
    mainFrame.setAttribute('tabindex', '0');
    mainFrame.setAttribute('aria-label', mainImage.alt || 'Agrandir l’image');
    mainFrame.classList.add('is-zoomable');

    mainFrame.addEventListener('click', () => open());
    mainFrame.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
      }
    });

    thumbs.forEach((thumb) => {
      const openThumb = () => {
        const image = thumb.querySelector('img');
        const source = thumb.dataset.acidologyLightboxSrc;
        if (source) open(source, image?.alt || '');
      };

      thumb.addEventListener('click', openThumb);
      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openThumb();
        }
      });
    });

    closeButton?.addEventListener('click', close);
    backdrop?.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) close();
    });
  });
})();
